<template>
	<div class="row">
		<div class="col-md-12">

			<h4 v-if=" getCategory != 'infantil' ">{{ $t('Buscador Avanzado Libros') }} </h4>
			
			<div class="row buscador-avanzado">
				<div class="col-md-6">					
	        <div class="form-head fix">
						
						<input-autocomplete
              :title="$t('Título')" 
              searchField="TITULO" 
              searchCategory="libros" :value.sync="frm.TITULO"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('ISBN')" 
              searchField="CODIGO" 
              searchCategory="libros" :value.sync="frm.CODIGO"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Autor/a')" 
              searchField="L_AUTORES" 
              searchCategory="libros" :value.sync="frm.L_AUTORES"
              :reset="reset">      
            </input-autocomplete>

	          <input-autocomplete
              :title="$t('Editorial')" 
              searchField="EDITOR" 
              searchCategory="libros" :value.sync="frm.EDITOR"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Temática')" 
              searchField="L_TEMAS" 
              searchCategory="libros" :value.sync="frm.L_TEMAS"
              :reset="reset">      
            </input-autocomplete>

	        </div>
				</div>

				<div class="col-md-6">

					<input-autocomplete
            :title="$t('Lengua')" 
            searchField="L_IDIOMAS" 
            searchCategory="libros" :value.sync="frm.L_IDIOMAS"
            :reset="reset">      
          </input-autocomplete>

	        <div class="input-group">
	          <div class="input-group-addon"><span>{{ $t('Año de edición') }}</span></div>
            <input type="number" class="form-control" :placeholder="$t('Año de edición')" maxlength="150" v-model="frm.L_ANO_EDICION">
	        </div>

	        <custom-select-box 
            :title="$t('Formato')" 
            searchField="FORMATO" 
            searchCategory="libros" :value.sync="frm.FORMATO"
            :reset="reset">
          </custom-select-box>
					
					<div class="row">
						<div class="col-xs-6">
							<div class="input-group mr10">
		          	<div class="input-group-addon"><span>{{ $t('Precio min') }}</span></div>
		            <input type="number" class="form-control" :placeholder="$t('Precio min')" maxlength="150" v-model="frm.PRECIO_MIN">
			        </div>
						</div>
						<div class="col-xs-6">
							<div class="input-group">
		          	<div class="input-group-addon"><span>{{ $t('Precio max') }}</span></div>
		            <input type="number" class="form-control" :placeholder="$t('Precio max')" maxlength="150" v-model="frm.PRECIO_MAX">
		        	</div>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-6">
							<div class="input-group">
			          <div class="input-group-addon"><span>{{ $t('Novedad') }}</span></div>
			          <input type="checkbox" v-model="frm.NOVEDAD">
			        </div>
						</div>
						<div class="col-xs-6">
							<div class="input-group">
			          <div class="input-group-addon"><span>{{ $t('Recomendado') }}</span></div>
			          <input type="checkbox" v-model="frm.RECOMENDADO">
			        </div>
						</div>
					</div>

				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

		        <div class="center">
              <button class="btn btn-tata mb40" type="submit" @click="resetForm">{{ $t('Vaciar') }} <i class="fa fa-remove"></i></button>
		          <button class="btn btn-tata mb40" type="submit" :disabled="loading" @click="submitSearch">{{ $t('Buscar') }} <i class="fa fa-search"></i></button>
		        </div>
				</div>
			</div>

		</div>	
	</div>
</template>

<i18n>
{
  "es": {
  	"Buscador Avanzado Libros": "Buscador Avanzado Libros",
  	"Título": "Título",
    "ISBN": "ISBN",
  	"Autor/a": "Autor/a",
  	"Editorial": "Editorial",
  	"Buscar": "Buscar",
  	"Temática": "Temática",
  	"Lengua": "Lengua",
  	"Año de edición": "Año de edición",
  	"Formato": "Formato",
		"Novedad": "Novedad",
		"Todos": "Todos",
		"Si": "Si",
		"Precio min": "Precio min",
		"Precio max": "Precio max",
		"Recomendado": "Recomendado",
		"Debe rellenar un campo como mínimo": "Debe rellenar un campo como mínimo",
    "Vaciar": "Vaciar"
  },
  "en": {
  },
  "ca": {
    "Buscador Avanzado Libros": "Cercador avançat Llibres",
    "Título": "Títol",
    "ISBN": "ISBN",
    "Autor/a": "Autor/a",
    "Editorial": "Editorial",
    "Buscar": "Cercar",
    "Temática": "Temàtica",
    "Lengua": "Llengua",
    "Año de edición": "Any d'edició",
    "Formato": "Format",
    "Novedad": "Novetat",
    "Todos": "Tots",
    "Si": "Sí",
    "Precio min": "Preu mín",
    "Precio max": "Preu màx",
    "Recomendado": "Recomanat",
    "Debe rellenar un campo como mínimo": "Ha d'omplir com a mínim un camp",
    "Vaciar": "Buidar"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';
	import CustomSelectBox from './CustomSelectBox.vue';
  import InputAutocomplete from './InputAutocomplete.vue';

  export default {
    props: ['searchCategory'],
    components: { CustomSelectBox, InputAutocomplete },  
    data: () => {
      return{
      	loading: false,
      	frm_error: false,
      	frm_error_message: '',
     		frm: {
          CODIGO: '',
          TITULO: '',
          L_AUTORES: '',
          EDITOR: '',
          L_TEMAS: '',
          L_IDIOMAS: '',
          L_ANO_EDICION: '',
          FORMATO: '',       
          PRECIO_MIN: '',
          PRECIO_MAX: '',   
          NOVEDAD: false ,        
          RECOMENDADO: false,
          a_tipo: ''
        },
        reset: false,
      }
    },
    mounted(){
    },
    computed: mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
    methods: {
      submitSearch() {
        this.frm_error = false;

        if( this.searchData() ){

          this.frm.a_tipo = (this.searchCategory) ? this.searchCategory.substr(0,1) : '';
          this.frm.NOVEDAD = (this.frm.NOVEDAD == false) ? '' : true;
          this.frm.RECOMENDADO = (this.frm.RECOMENDADO == false) ? '' : true;

          // COPIAR VARIABLES RELLENADAS
          let dataToSend = {};
          for (var prop in this.frm) {
            if (this.frm.hasOwnProperty(prop)) {
              if( this.frm[prop] != '' ){
                dataToSend[prop] = this.frm[prop];
              }
            }
          }

          // Añadir ref para stats
          dataToSend['ref'] = 'buscador_avanzado';

          this.$router.push({ 
          	name: 'buscador-avanzado', 
          	params: { language: this.getLocale, category: this.getCategory },
          	query: dataToSend
          })

        }else{
          this.frm_error_message = this.$t('Debe rellenar un campo como mínimo');
          this.frm_error = true;
        }
      },
      searchData(){
        for (var prop in this.frm) {
          if (this.frm.hasOwnProperty(prop)) {
            if( this.frm[prop] != '' && prop != 'a_tipo' ){
              return true;
            }
          }
        }
        return false;
      },
      resetForm(){
        this.reset = !this.reset;
        this.frm.L_ANO_EDICION = this.frm.PRECIO_MIN = this.frm.PRECIO_MAX = '';
        this.frm.NOVEDAD = this.frm.RECOMENDADO = false;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
